// extracted by mini-css-extract-plugin
module.exports = {"serviceWrapper":"additionalServiceWrapperContainer_serviceWrapper__3pTi-","updateBtnWrapper":"additionalServiceWrapperContainer_updateBtnWrapper__1JEJ8"};